import React from 'react'
import {Cookies} from "react-cookie-consent";
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {closeDialog} from '../../slices/dialog';
import Button from '../Common/Button';
import ReactMarkdown from "react-markdown";

const gfm = require("remark-gfm");

export const StudentProfileTutorial = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onClose = () => {
        Cookies.set("profileTutorialDone", true, {expires: 1000});
        dispatch(closeDialog());
    }

    return (
        <div className="studentProfileTutorial">
            <ReactMarkdown
                remarkPlugins={[gfm]}
                children={t("student_profileTutorial_p")}
                className="blogArticle__markdown"
            />
            <Button onClick={onClose}>{t("student_profileTutorial_btn")}</Button>
        </div>
    )
}